/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// eslint-disable-next-line no-console
// Theme info in console
// console.log('Custom Shopify Theme Developed By EcomGraduates LLC | https://www.ecomgraduates.com')
function logCredits() {
  const style = `
    display: inline-block;
    font-size: 14px;
    background: linear-gradient(90deg, rgba(185,61,244,1) 0%, rgba(219,33,153,1) 46%, rgba(250,5,64,1) 100%) !important;
    color: white;
    padding: 4px;
    border-radius: 4px;
  `;
  let message = `
    📈 Increased conversion rates
    📈 Increased average order value
    📈 Increased customer lifetime value
    📈 Best support for your success

    Learn more at: https://ecomgraduates.com
  `;
  console.group("%c🎓 Custom Shopify Theme by EcomGraduates. 🎓", style);
  console.log(`%c${message}`, "font-size: 14px;");
  console.groupEnd();
}
logCredits();

// Init Bootstrap tooltips
document.querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach((el) => new bootstrap.Tooltip(el));

// Init Bootstrap popovers
document.querySelectorAll('[data-bs-toggle="popover"]')
    .forEach((el) => new bootstrap.Popover(el));

// Shopify's callenge page - Add BS classes
document.querySelector('.btn.shopify-challenge__button')
    ?.classList.add('btn-primary');

// Shopify's errors messages - Add BS classes
const errors = document.querySelector('.errors');
if (errors) {
    errors.classList.add('alert', 'alert-danger');
    errors.querySelector('ul').classList.add('mb-0');
}

// Detect when element is within the scroll view
const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('.enter-view-entered');
            entry.target.querySelectorAll('.animate__animated.opacity-0').forEach((el) => {
                el.classList.remove('opacity-0');
                el.classList.add(el.dataset.animateClass);
            });
        }
    });
}, { threshold: 0, rootMargin: '0px 0px -200px 0px' });

document.querySelectorAll('.enter-view').forEach((el) => {
    observer.observe(el);
});

// Handle Plus/Minus in quantity steppers
window.qtyDecrease = (btn) => {
    const input = btn.closest('.quantity-wrapper').querySelector('input');
    const inputValue = Number(input.value);

    if (inputValue > 1) {
        input.value = inputValue - 1;
    }
};

window.qtyIncrease = (btn) => {
    const input = btn.closest('.quantity-wrapper').querySelector('input');
    const inputValue = Number(input.value);

    input.value = inputValue + 1;
};

// Show second image on hover on product list items
document.querySelectorAll('img[data-second-img]').forEach((img) => {
    img.closest('a').addEventListener('mouseover', () => {
        img.src = img.dataset.secondImg;
    });
    img.closest('a').addEventListener('mouseleave', () => {
        img.src = img.dataset.firstImg;
    });
});

// Fix Klaviyo back in stock stylings
const fixKlaviyoBackInStock = () => {
    setInterval(() => {
        document.querySelectorAll('form[action="/cart/add"] .btn.btn--full').forEach((btn) => {
            btn.classList.add('btn-primary', 'w-100');
        });
    }, 2000);
};
fixKlaviyoBackInStock();

//show final sale badge
function removeOpacity() {
  const elements = document.querySelectorAll('.finalSaleBadge');
  elements.forEach(element => {
    element.classList.remove('opacity-0');
  });
}

window.addEventListener('load', removeOpacity);
